'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Media = require('react-bootstrap/lib/Media');

var _Media2 = _interopRequireDefault(_Media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Media2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/Media.js
// module id = 632
// module chunks = 0